import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Button } from "devextreme-react";
import DataSource from "devextreme/data/data_source";
import DataGrid, { Column, Paging, Pager, RemoteOperations } from "devextreme-react/ui/data-grid";
import moment from "moment";
import LoadingGif from "../../../../../images/animacion2[18].gif";
import { getSiniestrosApi } from "../../../../../services/siniestrosApi";
import { setSiniestros } from "./actions";
import HeaderTooltip from "../../../../Shared/headerTooltip";
import { openCloseToast } from "../../../../Global/actions";
import ModalDocumentos from "../../../Documentos/modalDocumentos";
import TableFilter from "../../../../Shared/tableFilter.jsx";
import { getFiltros, filterData, filterType } from "../../../../../helpers/filterHelper";
import { doGetDocumentBySiniestro } from "../../../Documentos/actions";
import validaciones from "../../../../../helpers/validaciones";
import SiniestroInfoColumn from "../../../../Shared/SiniestroInfoColumn";
import {
  CanAppeal,
  ClaimsJustificationsArray,
  ClaimsQualifications,
  ClaimsQualificationsTypes,
  ClaimsTypeQualificationsTypes,
  ClaimsTypes,
} from '../../../../../helpers/claimsConstants';

const ActionButton = (props) => (
  <Button
    type={props.type}
    text={props.text}
    onClick={props.onClick}
    style={props.style}
    render={(btn) => (
      <div
        style={{
          padding: "7px 0px 0px 0px",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",

        }}
      >{btn.text}
      </div>
    )}
  />
);

const columnToFilter = [
  {
    column: "Reposo",
    name: "Reposo",
    type: filterType.bool,
    values: [{ text: "Activo", value: true }, { text: "No Activo", value: false }],
  },
  { column: "TipoSiniestro", name: "Tipo" },
  { column: "Calificacion", name: "Cobertura" },
  { column: "NombreEmpresa", name: "Empresa" },
  {
    column: "FechaPresentacion",
    name: "Fecha presentación",
    type: filterType.date,
    max: new Date(),
  },
  {
    column: "FechaSiniestro",
    name: "Fecha siniestro",
    type: filterType.date,
    max: new Date(),
  },
  {
    column: "PrestacionesEconomicas",
    name: "Prestaciones económicas",
    type: filterType.bool,
    values: [{ text: "Si", value: true }, { text: "No", value: false }],
  },
];

const removeAccents = str =>
  str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

const isForbiddenAppeal = (value) => {
  return (
    value.TipoSiniestro2 === ClaimsTypes.Journey &&
    value.Calificacion === ClaimsQualifications.DoesNotAcceptClaims &&
    removeAccents(value.TipoCalificacion) === ClaimsTypeQualificationsTypes.AdministrativeQualification &&
    ClaimsJustificationsArray.includes(value.Justificacion)
  );
};

class TableSiniestros extends React.PureComponent {
  constructor(props) {
    super(props);

    this.tableRef = React.createRef();
    this.contador = 0;
    this.loadingDocs = false;
    this.state = {
      filtersLoaded: false,
    };

    this.dataSource = new DataSource({
      load: async (options) => {
        try {
          this.contador = this.contador + 1;
          let data = this.props.listaSiniestros || [];
          let totalCount =
            (this.props.listaSiniestros != null && this.props.listaSiniestros.length) || 0;

          if (!this.state.filtersLoaded) {
            const request = await getSiniestrosApi(
              this.props.userData.RUT,
              options.skip,
              options.skip + options.take,
              options.filter,
            );
            if (request.status === 200) {
              const result = await request.json();
              const filtros = getFiltros(columnToFilter, result.Siniestros);
              this.props.dispatch(setSiniestros(result.Siniestros, filtros));
              this.setState({ filtersLoaded: true });
              data = result.Siniestros || [];
              totalCount = data.length;

              if (data.length) {
                data.sort((a, b) => {
                  // Turn your strings into dates, and then subtract them
                  // to get a value that is either negative, positive, or zero.
                  return new Date(b.FechaSiniestro) - new Date(a.FechaSiniestro);
                });

                const claimsIds = [];
                data.forEach((value) => {
                  const givenDay = moment(value.FechaCalificacion, 'YYYY-MM-DD');
                  const currentDay = moment().startOf('day');

                  const differenceInNumberOfDays =
                    moment.duration(currentDay.diff(givenDay)).asDays() - 1;

                  if (
                    value.TipoSiniestro === ClaimsTypes.NoLaw &&
                    (
                      (
                        value.TipoSiniestro2 === ClaimsQualificationsTypes.ProfessionalIllness &&
                        differenceInNumberOfDays <= 365
                      ) ||
                      (
                        (
                          value.TipoSiniestro2 === ClaimsQualificationsTypes.Work ||
                          value.TipoSiniestro2 === ClaimsQualificationsTypes.Journey
                        ) &&
                        differenceInNumberOfDays <= 90
                      )
                    )
                    &&
                    !isForbiddenAppeal(value)
                  ) {
                    claimsIds.push(
                      `${value.IdSiniestro};${value.TipoSiniestro2};${CanAppeal.Yes}`,
                    );
                  }

                  if (isForbiddenAppeal(value)) {
                    claimsIds.push(
                      `${value.IdSiniestro};${value.TipoSiniestro2};${CanAppeal.No}`,
                    );
                  }
                });

                localStorage.setItem('claimsIds', JSON.stringify(claimsIds));
              }
            }
          }

          if (options.filter && options.filter.length > 0) {
            const newData = filterData(this.props.listaSiniestros, options.filter);
            return {
              data: newData,
              totalCount: newData.length,
            };
          }

          return {
            totalCount,
            data,
          };
        } catch (e) {
          console.error(e);
          this.props.dispatch(
            openCloseToast({
              isToastOpen: true,
              msgToast: 'Error al obtener la lista de siniestros',
              typeStyle: 'error',
              displayTime: 5000,
            }),
          );

          return {
            totalCount: 0,
            data: [],
          };
        }
      },
    });
  }
//
  handleViewDocuments = (rowData) => {
    this.loadingDocs = true;
    const IdSiniestro = rowData.data.IdSiniestro;
    const data = {
      ...rowData.data,
      tipoBusqueda: "T",
    };

    this.props.dispatch(doGetDocumentBySiniestro(IdSiniestro, data));
    this.props.postTagManager({label: 'Clic Btn: Documentos'}, this.props.dispatch)
  }

  handleFilterChange = (text, filters) => {
    const currentFilters = [...filters];
    if (text) currentFilters.push({ column: "IdSiniestro", value: { text, value: text }, type: filterType.search });
    this.tableRef.filter(currentFilters);
    this.tableRef.searchByText(text);
  }

  handleButtonClick = () => {
    this.loadingDocs = false;
  }

  render() {
    return (
      <React.Fragment>
        <ModalDocumentos postTagManager={this.props.postTagManager} />

        <TableFilter
          placeholder="Buscar siniestros por ID"
          onChange={this.handleFilterChange}
          filters={this.props.filtrosTablaSiniestro}
          show={false}
          buttons={
            {
              filter: { buttonName: "iconFilter", visible: true, buttonAction: null },
              document: null,
              download: { buttonName: "iconDownload", visible: false, buttonAction: null },
              newItem: { buttonName: "custom", visible: false, buttonAction: null },

            }
          }
        />

        <DataGrid
          dataSource={this.dataSource}
          ref={(ref) => { if (ref !== null) this.tableRef = ref.instance; }}
          showBorders={false}
          showColumnLines={false}
          showRowLines={false}
          className="custom-table"
          noDataText=""
          rowAlternationEnabled
          hoverStateEnabled
          selection={{
            mode: "single",
          }}
          onRowClick={(row) => {
            if (this.loadingDocs) {
              this.handleButtonClick();
            } else {
              this.props.handleDetails(1, row.data);
            }
          }}
          onContentReady={(e) => {
            if (e.component.totalCount() === 0) {
              const config = {};
              config.addClass = "table-margin";
              const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
              const element = validaciones.noDataDOMElement(config, "Sin siniestros");
              noDataSpan.appendChild(element);
            }
          }}
          loadPanel={{
            enabled: true,
            showPane: true,
            showIndicator: true,
            indicatorSrc: LoadingGif,
            text: "Cargando...",
          }}
        >

          <Column
            allowSearch
            calculateCellValue={(rowData) => `${rowData.Reposo} ${rowData.IdSiniestro} ${rowData.TipoSiniestro}`}
            caption="Siniestro"
            allowFiltering
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <SiniestroInfoColumn
                  active={row.data.Reposo}
                  title={row.data.TipoSiniestro}
                  subtitle={Number(row.data.IdSiniestro).toString()}
                />
                , element
              );
            }}
          />


          <Column
            dataField="Calificacion"
            caption="Cobertura"
            allowFiltering
            allowSearch={false}
          />
          <Column
            dataField="NombreEmpresa"
            caption="Empresa"
            allowFiltering
            allowSearch={false}
          />

          <Column
            dataField="FechaSiniestro"
            caption="Fecha siniestro"
            allowFiltering={false}
            allowSearch={false}
            dataType="date"
            alignment="center"
            sortIndex={0}
            sortOrder="asc"
            sortingMethod={(v1, v2) => {
              const v1d = moment(v1, "DD/MM/YYYY");
              const v2d = moment(v2, "DD/MM/YYYY");
              if (v1d.isAfter(v2d)) return -1;
              if (v1d.isSame(v2d)) return 0;
              if (v1d.isBefore(v2d)) return 1;
              return 0;
            }}
            format="dd/MM/yyyy"
          />

          <Column
            dataField="FechaPresentacion"
            caption="Fecha presentación"
            allowFiltering={false}
            allowSearch={false}
            alignment="center"
            dataType="date"
            format="dd/MM/yyyy"
          />


          <Column
            dataField="PrestacionesEconomicas"
            headerCellTemplate={(element, row) => ReactDOM.render(<HeaderTooltip
              id="tooltipPrestaciones"
              widthprops={250}
              headerText="Prestaciones económicas"
              toolTipText="Prestaciones económicas, subsidios, indemnizaciones y/o pensiones que puede recibir el trabajador dependiendo del diagnóstico médico."
            />, element)}
            caption="Prestaciones económicas"
            allowFiltering
            allowSearch={false}
            headerFilter={{
              dataSource: [
                { text: "Si", value: true },
                { text: "No", value: false },
              ],
            }}
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <div>{row.data.PrestacionesEconomicas ? <i className="achs-icon siniestros-empresa active "> c </i> : <i className="achs-icon siniestros-empresa"> d </i>}</div>
                , element
              );
            }}
          />
          <Column
            caption="Documentos"
            alignment="center"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <ActionButton
                  width="40"
                  height="25"
                  text="Ver"
                  type="success"
                  onClick={() => this.handleViewDocuments(row)}
                />
                , element
              );
            }}
          />

          <RemoteOperations
            paging={false}
            filtering
            summary={false}
            groupPaging={false}
            grouping={false}
            sorting={false}
          />

          <Paging
            defaultPageSize={12}
          />

          <Pager
            showNavigationButtons
            showInfo
            infoText={(page, total) => `Página ${page} de ${total}`}
          />
        </DataGrid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  listaSiniestros: state.siniestro.listaSiniestros,
  filtrosTablaSiniestro: state.siniestro.filtrosTablaSiniestro,
  viewDetails: state.siniestro.viewDetails,
  userData: state.global.userData,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TableSiniestros);
